/* Arange · Icono de wishlist del header ↔ app Wishlist Hero.

   La app expone su acceso como un lanzador flotante (`.wishlisthero-floating-launcher-container`).
   Ese flotante queda invisible por CSS —el diseño pide el corazón en el header— y este
   script hace de puente: revela nuestro icono cuando la app ha cargado, le pasa el
   clic al lanzador para abrir el panel, y refleja el número de guardados.

   La JS API oficial (OpenWishList/GetWishListItemsCount) es de pago; mientras la
   tienda esté en el plan gratuito, este puente es la vía.

   OJO: el observador vigila SOLO el lanzador y `paint()` sale si el número no
   cambió. Observar el body entero y escribir dentro del callback se retroalimenta
   y cuelga la pestaña. */
(function () {
  var LAUNCHER = '.wishlisthero-floating-launcher-container';
  var TIMEOUT = 15000;

  var btn = document.querySelector('[data-arange-wishlist-open]');
  if (!btn) return;
  var counter = btn.querySelector('[data-arange-wishlist-count]');
  var launcherObs = null;
  var last = null;

  function readCount(el) {
    var n = parseInt((el.textContent || '').replace(/\D/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  function paint(n) {
    if (n === last) return;
    last = n;
    if (!counter) return;
    if (n > 0) {
      counter.textContent = String(n);
      counter.hidden = false;
    } else {
      counter.textContent = '';
      counter.hidden = true;
    }
  }

  function attach(el) {
    btn.hidden = false;
    paint(readCount(el));
    if (launcherObs) return;
    launcherObs = new MutationObserver(function () {
      paint(readCount(el));
    });
    launcherObs.observe(el, { childList: true, subtree: true, characterData: true });
  }

  btn.addEventListener('click', function () {
    var el = document.querySelector(LAUNCHER);
    var link = el && el.querySelector('a, button');
    if (link) link.click();
  });

  function boot() {
    var el = document.querySelector(LAUNCHER);
    if (el) { attach(el); return; }

    var bodyObs = new MutationObserver(function () {
      var found = document.querySelector(LAUNCHER);
      if (!found) return;
      bodyObs.disconnect();
      attach(found);
    });
    bodyObs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { bodyObs.disconnect(); }, TIMEOUT);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
